import React from "react";
import { Route, Routes } from "react-router-dom";
import MainPersonPage from "./MainPersonPage";
import ProtectedRoute from "../../ProtectedRoute";
import AddEditPersonPage from "./AddEditPersonPage";
import ViewPersonPage from "./ViewPersonPage";
import PageNotFound from "../PageNotFound";

const PersonRouter: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ProtectedRoute element={<MainPersonPage />} />} />
      <Route
        path="create"
        element={<ProtectedRoute element={<AddEditPersonPage />} />}
      />
      <Route
        path=":_id/edit"
        element={<ProtectedRoute element={<AddEditPersonPage />} />}
      />
      <Route
        path=":_id"
        element={<ProtectedRoute element={<ViewPersonPage />} />}
      />
      <Route path="*" element={<PageNotFound />} />
    </Routes>
  );
};

export default PersonRouter;
